const MidleTaskbar = ({ currentTab, children, isExtend }) => {
  console.log("kamskdma");
  return (
    <div
      className={
        isExtend
          ? "wrapper-document-view-extend"
          : currentTab === null
          ? "wrapper-document-view active-icon"
          : "wrapper-document-view"
      }
    >
      <div className="document-view-iframe">{children}</div>
    </div>
  );
};

export default MidleTaskbar;
